<template>
	<vue-final-modal v-slot="{ close }" v-bind="$attrs" classes="modal--container" content-class="modal--content qr-modal" v-on="$listeners">
		<img :src="qrCodeUrl" />
	</vue-final-modal>
</template>

<script>
	export default {
		name: 'QRModal',
		props: {
			qrCodeUrl: {
				type: String,
				required: true,
			},
		},
	};
</script>
